export default "/packs/images/261x300~ec59925f0106af0d38bdff6badeecc03.png";